// import React, { useEffect, useState } from "react";
// import "./style.css";
// import { useDispatch, useSelector } from "react-redux";
// import { popularProfessionalOpenSearch } from "../../redux/slices/SearchFilterSlice";
// import PopularProfessionalCard from "./PopularProfessionalCard";
// import { Link } from "react-router-dom";

// const PopularProfessionalOpenSearch = () => {
//   const user = useSelector((state) => state?.AuthSlice?.user);
//   const userRole = user?.role?.name;

//   const [searchText, setSearchText] = useState(""); // <-- new search input
//   const [btnLoading, setBtnLoading] = useState(false);
//   const [defaultLocationChange, setDefaultLocationChange] = useState("United States");

//   const dispatch = useDispatch();
//   const professionals = useSelector((state) => state.SearchFilterSlice.popularProfessionals);

//   useEffect(() => {
//     // load initial professionals without filter
//     popularProfessionalHandler();
//   }, []);

//   const popularProfessionalHandler = async () => {
//     setBtnLoading(true);
//     const payload = { search: searchText || "" }; // send search text to backend
//     const res = await dispatch(popularProfessionalOpenSearch(payload));
//     if (res.payload.status === 200) {
//       setDefaultLocationChange(searchText || "United States");
//     }
//     setBtnLoading(false);
//   };

//   return (
//     <>
//       <div className="popular-professionals-box">
//         <div className="container">
//           <div className="row">
//             <div className="col-md-12">
//               <div className="home-banner-text">
//                 <h1 className="mb-4">Search Verified Professionals In Town</h1>
//               </div>
//             </div>
//           </div>

//           {/* Search Box */}
//           <div className="row justify-content-center">
//             <div className="col-md-12">
//               <div className="professional-search-box-home">
//                 <input
//                   type="text"
//                   className="home-banner-search"
//                   placeholder="Search by service or address"
//                   value={searchText}
//                   onChange={(e) => setSearchText(e.target.value)}
//                 />

//                 <button
//                   className="btn btn-primary btn-box-home"
//                   disabled={btnLoading}
//                   onClick={popularProfessionalHandler}
//                 >
//                   {!btnLoading ? (
//                     "Find"
//                   ) : (
//                     <i
//                       style={{ fontSize: "22px" }}
//                       className="fa-solid fa-spinner fa-spin"
//                     ></i>
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Results */}
//         <div className="popular-professional-box">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-12">
//                 <h1 className="home-main-heading">Verified Professionals</h1>
//                 {/* <p className="common-text">
//                   <i className="fa-solid fa-location-dot"></i>{" "}
//                   {defaultLocationChange}
//                 </p> */}
//               </div>

//               <div className="col-md-12">
//                 {professionals?.data?.length > 0 ? (
//                   <div className="popular-card-box">
//                     {professionals?.data?.map((professional, index) => (
//                       <Link
//                         to={`/service/provider/${professional?.id}`}
//                         key={index}
//                         style={{
//                           pointerEvents: userRole === "user" ? "auto" : "none",
//                           opacity: userRole === "user" ? 1 : 0.7,
//                           cursor:
//                             userRole === "user" ? "pointer" : "not-allowed",
//                         }}
//                       >
//                         <PopularProfessionalCard professional={professional} />
//                       </Link>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="no-data-found-box-homepage">
//                     <img
//                       src="/images/No-data-cuate.png"
//                       alt="No Data Found"
//                     />
//                     <h2>No Data Found</h2>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PopularProfessionalOpenSearch;





import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { popularProfessionalOpenSearch } from "../../redux/slices/SearchFilterSlice";
import PopularProfessionalCard from "./PopularProfessionalCard";
import { Link } from "react-router-dom";

const PopularProfessionalOpenSearch = () => {
  const user = useSelector((state) => state?.AuthSlice?.user);
  const userRole = user?.role?.name;

  const [searchText, setSearchText] = useState(""); // <-- new search input
  const [btnLoading, setBtnLoading] = useState(false);

  const dispatch = useDispatch();
  const professionals = useSelector(
    (state) => state.SearchFilterSlice.popularProfessionals
  );

  const isFirstRender = useRef(true);

  useEffect(() => {
    // Load immediately on mount; debounce while the user is typing so we
    // don't fire a request on every keystroke.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      popularProfessionalHandler();
      return;
    }

    const debounceTimer = setTimeout(() => {
      popularProfessionalHandler();
    }, 400);

    return () => clearTimeout(debounceTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const popularProfessionalHandler = async () => {
    setBtnLoading(true);
    const payload = { search: searchText || "" }; // send search text to backend
    const res = await dispatch(popularProfessionalOpenSearch(payload));
    setBtnLoading(false);
  };

  return (
    <>
      <div className="popular-professionals-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="home-banner-text">
                <h1 className="mb-4">Search Verified Professionals In Town</h1>
              </div>
            </div>
          </div>

          {/* Search Box */}
          <div className="row justify-content-center">
            <div className="col-md-12 d-flex align-items-center justify-content-center">
              <div className="professional-search-box-home">
                <input
                  type="text"
                  className="home-banner-search"
                  placeholder="Search by service, address or name"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      popularProfessionalHandler(); // trigger search on Enter
                    }
                  }}
                />

                <button
                  className="btn btn-primary btn-box-home"
                  disabled={btnLoading}
                  onClick={popularProfessionalHandler}
                >
                  {!btnLoading ? (
                    "Find"
                  ) : (
                    <i
                      style={{ fontSize: "22px" }}
                      className="fa-solid fa-spinner fa-spin"
                    ></i>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="popular-professional-box">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1 className="home-main-heading">Verified Professionals</h1>
              </div>

              <div className="col-md-12">
                {professionals?.data?.length > 0 ? (
                  <div className="popular-card-box">
                    {professionals?.data?.map((professional, index) => (
                      <Link
                        to={`/service/provider/${professional?.id}`}
                        key={index}
                        // style={{
                        //   pointerEvents: userRole === "user" ? "auto" : "none",
                        //   opacity: userRole === "user" ? 1 : 0.7,
                        //   cursor:
                        //     userRole === "user" ? "pointer" : "not-allowed",
                        // }}
                      >
                        <PopularProfessionalCard professional={professional} />
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="no-data-found-box-homepage">
                    <img
                      src="/images/No-data-cuate.png"
                      alt="No Data Found"
                    />
                    <h2>No Data Found</h2>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopularProfessionalOpenSearch;
